import api from "../../services/api";
import {
  GET_CHAPTERS_BY_MODULE_ID_FAILURE,
  GET_CHAPTERS_BY_MODULE_ID_REQUEST,
  GET_CHAPTERS_BY_MODULE_ID_SUCCESS,
  GET_CHAPTER_BY_ID_REQUEST,
  GET_CHAPTER_BY_ID_SUCCESS,
  GET_CHAPTER_BY_ID_FAILURE,
  DELETE_CHAPTER_REQUEST,
  DELETE_CHAPTER_SUCCESS,
  DELETE_CHAPTER_FAILURE,
  UPDATE_CHAPTER_REQUEST,
  UPDATE_CHAPTER_SUCCESS,
  UPDATE_CHAPTER_FAILURE,
  REUPLOAD_VIDEO_INIT_REQUEST,
  REUPLOAD_VIDEO_INIT_SUCCESS,
  REUPLOAD_VIDEO_INIT_FAILURE,
  UPDATE_ARTICLE_REQUEST,
  UPDATE_ARTICLE_SUCCESS,
  UPDATE_ARTICLE_FAILURE,
  GET_ARTICLE_BY_CHAPTER_ID_REQUEST,
  GET_ARTICLE_BY_CHAPTER_ID_SUCCESS,
  GET_ARTICLE_BY_CHAPTER_ID_FAILURE,
  CLEAR_ARTICLE_CONTENT,
  DELETE_ARTICLE_REQUEST,
  DELETE_ARTICLE_SUCCESS,
  DELETE_ARTICLE_FAILURE,
  RESET_ADD_CHAPTER,
} from "./ActionType";

const getChaptersByModuleIdRequest = () => {
  return {
    type: GET_CHAPTERS_BY_MODULE_ID_REQUEST,
  };
};

const getChaptersByModuleIdSuccess = (chapters) => {
  return {
    type: GET_CHAPTERS_BY_MODULE_ID_SUCCESS,
    payload: chapters,
  };
};

const getChaptersByModuleIdFailure = (error) => {
  return {
    type: GET_CHAPTERS_BY_MODULE_ID_FAILURE,
    payload: error,
  };
};

// Rate limiting map to prevent too many rapid requests
const requestTimestamps = new Map();

export const getChaptersByModuleId = (moduleId) => async (dispatch) => {
  const now = Date.now();
  const lastRequestTime = requestTimestamps.get(moduleId) || 0;
  const timeSinceLastRequest = now - lastRequestTime;
  
  // Rate limit: minimum 1 second between requests for the same module
  if (timeSinceLastRequest < 1000) {
    console.log(`Rate limited: Request for module ${moduleId} too soon`);
    return;
  }
  
  requestTimestamps.set(moduleId, now);
  
  dispatch(getChaptersByModuleIdRequest());
  try {
    const response = await api.get(`/chapters/by-module/${moduleId}`);
    const chapters = response.data;
    dispatch(getChaptersByModuleIdSuccess(chapters));
  } catch (error) {
    dispatch(getChaptersByModuleIdFailure(error.response.data));
  }
};

const getChapterByIdRequest = () => {
  return {
    type: GET_CHAPTER_BY_ID_REQUEST,
  };
};

const getChapterByIdSuccess = (chapter) => {
  return {
    type: GET_CHAPTER_BY_ID_SUCCESS,
    payload: chapter,
  };
};

const getChapterByIdFailure = (error) => {
  return {
    type: GET_CHAPTER_BY_ID_FAILURE,
    payload: error,
  };
};

export const getChapterById = (chapterId) => async (dispatch) => {
  dispatch(getChapterByIdRequest());
  try {
    const response = await api.get(`/chapters/${chapterId}`);
    console.log("Chapter API Response:", response.data); // Debug log
    
    // Handle the API response structure: { success, message, data }
    if (response.data.success && response.data.data) {
      const chapterData = response.data.data;
      // Transform the API response to match our expected structure
      const chapter = {
        id: chapterData.chapterId,
        title: chapterData.chapterTitle,
        description: chapterData.chapterDescription,
        type: chapterData.chapterType,
        orderIndex: chapterData.chapterOrder,
        contentUrl: chapterData.contentUrl,
        moduleId: chapterData.moduleId,
        createdAt: chapterData.createdAt,
        updatedAt: chapterData.updatedAt
      };
      dispatch(getChapterByIdSuccess(chapter));
    } else {
      dispatch(getChapterByIdFailure("Invalid API response structure"));
    }
  } catch (error) {
    console.error("Chapter API Error:", error.response?.data || error.message);
    dispatch(getChapterByIdFailure(error.response?.data || error.message));
  }
};

const addChapterRequest = () => {
  return {
    type: "ADD_CHAPTER_REQUEST",
  };
};

const addChapterSuccess = (chapter) => {
  return {
    type: "ADD_CHAPTER_SUCCESS",
    payload: chapter,
  };
};

const addChapterFailure = (error) => {
  return {
    type: "ADD_CHAPTER_FAILURE",
    payload: error,
  };
};

export const addChapter = (moduleId, chapterData) => async (dispatch) => {
  dispatch(addChapterRequest());
  try {
    const response = await api.post(
      `/chapters/module/${moduleId}`,
      chapterData
    );
    const chapter = response.data;
    dispatch(addChapterSuccess(chapter));
  } catch (error) {
    dispatch(addChapterFailure(error.response.data));
  }
};

const deleteChapterRequest = () => {
  return {
    type: DELETE_CHAPTER_REQUEST,
  };
};

const deleteChapterSuccess = (chapterId) => {
  return {
    type: DELETE_CHAPTER_SUCCESS,
    payload: chapterId,
  };
};

const deleteChapterFailure = (error) => {
  return {
    type: DELETE_CHAPTER_FAILURE,
    payload: error,
  };
};

export const deleteChapter = (chapterId) => async (dispatch) => {
  dispatch(deleteChapterRequest());
  try {
    await api.delete(`/chapters/${chapterId}`);
    dispatch(deleteChapterSuccess(chapterId));
  } catch (error) {
    dispatch(deleteChapterFailure(error.response.data));
  }
};

const updateChapterOrderRequest = () => {
  return {
    type: "UPDATE_CHAPTER_ORDER_REQUEST",
  };
};

const updateChapterOrderSuccess = () => {
  return {
    type: "UPDATE_CHAPTER_ORDER_SUCCESS",
  };
};

const updateChapterOrderFailure = (error) => {
  return {
    type: "UPDATE_CHAPTER_ORDER_FAILURE",
    payload: error,
  };
};

export const updateChapterOrder = (orderMap) => async (dispatch) => {
  dispatch(updateChapterOrderRequest());
  try {
    await api.put("/chapters/update-order", orderMap);
    dispatch(updateChapterOrderSuccess());
  } catch (error) {
    dispatch(updateChapterOrderFailure(error.response?.data || error.message));
  }
};

// Update Chapter Actions
const updateChapterRequest = () => {
  return {
    type: UPDATE_CHAPTER_REQUEST,
  };
};

const updateChapterSuccess = (chapter) => {
  return {
    type: UPDATE_CHAPTER_SUCCESS,
    payload: chapter,
  };
};

const updateChapterFailure = (error) => {
  return {
    type: UPDATE_CHAPTER_FAILURE,
    payload: error,
  };
};

export const updateChapter = (chapterId, updateData) => async (dispatch) => {
  dispatch(updateChapterRequest());
  try {
    const response = await api.put(`/chapters/${chapterId}`, updateData);
    console.log("Update Chapter API Response:", response.data); // Debug log
    
    // Handle the API response structure
    if (response.data.success && response.data.data) {
      const updatedChapter = response.data.data;
      dispatch(updateChapterSuccess(updatedChapter));
    } else {
      dispatch(updateChapterSuccess(response.data));
    }
  } catch (error) {
    console.error("Update Chapter API Error:", error.response?.data || error.message);
    dispatch(updateChapterFailure(error.response?.data || error.message));
  }
};

// Reupload Video Init Actions
const reuploadVideoInitRequest = () => {
  return {
    type: REUPLOAD_VIDEO_INIT_REQUEST,
  };
};

const reuploadVideoInitSuccess = (uploadDetails) => {
  return {
    type: REUPLOAD_VIDEO_INIT_SUCCESS,
    payload: uploadDetails,
  };
};

const reuploadVideoInitFailure = (error) => {
  return {
    type: REUPLOAD_VIDEO_INIT_FAILURE,
    payload: error,
  };
};

export const reuploadVideoInit = (chapterId) => async (dispatch) => {
  dispatch(reuploadVideoInitRequest());
  try {
    const response = await api.post(`/chapters/${chapterId}/reupload-video-init`);
    console.log("Reupload Video Init API Response:", response.data);
    
    if (response.data.success && response.data.data) {
      dispatch(reuploadVideoInitSuccess(response.data.data));
    } else {
      dispatch(reuploadVideoInitFailure(response.data.message || "Failed to initialize video reupload"));
    }
  } catch (error) {
    console.error("Reupload Video Init API Error:", error.response?.data || error.message);
    dispatch(reuploadVideoInitFailure(error.response?.data || error.message));
  }
};

// Update Article Actions
const updateArticleRequest = () => {
  return {
    type: UPDATE_ARTICLE_REQUEST,
  };
};

const updateArticleSuccess = (articleData) => {
  return {
    type: UPDATE_ARTICLE_SUCCESS,
    payload: articleData,
  };
};

const updateArticleFailure = (error) => {
  return {
    type: UPDATE_ARTICLE_FAILURE,
    payload: error,
  };
};

export const updateArticle = (chapterId, articleContent) => async (dispatch) => {
  dispatch(updateArticleRequest());
  try {
    const response = await api.put(`/chapters/${chapterId}/articles`, articleContent, {
      headers: {
        'Content-Type': 'text/plain',
      },
    });
    console.log("Update Article API Response:", response.data);
    
    if (response.data.success) {
      dispatch(updateArticleSuccess(response.data));
    } else {
      dispatch(updateArticleFailure(response.data.message || "Failed to update article"));
    }
  } catch (error) {
    console.error("Update Article API Error:", error.response?.data || error.message);
    dispatch(updateArticleFailure(error.response?.data || error.message));
  }
};

// Get Article by Chapter ID Actions
const getArticleByChapterIdRequest = () => {
  return {
    type: GET_ARTICLE_BY_CHAPTER_ID_REQUEST,
  };
};

const getArticleByChapterIdSuccess = (articleContent) => {
  return {
    type: GET_ARTICLE_BY_CHAPTER_ID_SUCCESS,
    payload: articleContent,
  };
};

const getArticleByChapterIdFailure = (error) => {
  return {
    type: GET_ARTICLE_BY_CHAPTER_ID_FAILURE,
    payload: error,
  };
};

export const getArticleByChapterId = (chapterId) => async (dispatch) => {
  dispatch(getArticleByChapterIdRequest());
  try {
    const response = await api.get(`/chapters/${chapterId}/articles`);
    console.log("Get Article by Chapter ID API Response:", response.data);
    
    if (response.data.success && response.data.data) {
      dispatch(getArticleByChapterIdSuccess(response.data.data));
    } else {
      dispatch(getArticleByChapterIdFailure(response.data.message || "Failed to get article content"));
    }
  } catch (error) {
    console.error("Get Article by Chapter ID API Error:", error.response?.data || error.message);
    dispatch(getArticleByChapterIdFailure(error.response?.data || error.message));
  }
};

export const clearArticleContent = () => {
  return {
    type: CLEAR_ARTICLE_CONTENT,
  };
};

// Delete Article Actions
const deleteArticleRequest = () => {
  return {
    type: DELETE_ARTICLE_REQUEST,
  };
};

const deleteArticleSuccess = (chapterId) => {
  return {
    type: DELETE_ARTICLE_SUCCESS,
    payload: chapterId,
  };
};

const deleteArticleFailure = (error) => {
  return {
    type: DELETE_ARTICLE_FAILURE,
    payload: error,
  };
};

export const deleteArticle = (chapterId) => async (dispatch) => {
  dispatch(deleteArticleRequest());
  try {
    const response = await api.delete(`/chapters/${chapterId}/articles`);
    console.log("Delete Article API Response:", response.data);
    
    if (response.data.success) {
      // Use the chapterId as the payload since the API returns true in data field
      dispatch(deleteArticleSuccess(chapterId));
    } else {
      dispatch(deleteArticleFailure(response.data.message || "Failed to delete article"));
    }
  } catch (error) {
    console.error("Delete Article API Error:", error.response?.data || error.message);
    dispatch(deleteArticleFailure(error.response?.data || error.message));
  }
};

// Reset Add Chapter Result Action
export const resetAddChapterResult = () => {
  return {
    type: RESET_ADD_CHAPTER,
  };
};
